import React from 'react';
import { Outlet } from 'react-router-dom';

export const DictionaryLayout = (): React.JSX.Element => {
    return (
        <>
            <Outlet />
        </>
    );
};
